/* unplugin-vue-components disabled */import { render } from "./rednote.vue?vue&type=template&id=04abe56f&scoped=true"
import script from "./rednote.vue?vue&type=script&lang=js"
export * from "./rednote.vue?vue&type=script&lang=js"

import "./rednote.vue?vue&type=style&index=0&id=04abe56f&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04abe56f"]])

export default __exports__